// --- Logic --------------------------------------------------------------------------------------
/**
 * Mirrors `URL_SAFE_REGEX` in the backend — keep the two in step, or this form will accept what the
 * API rejects. Lowercase letters and digits, single hyphens between words, nothing at either end.
 */
const SLUG_REGEX = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

/**
 * Cleans a slug **as it is typed**. The value becomes a live subdomain — `{slug}.lozicore.com`, the
 * company's public catalog — so anything that cannot survive being one never reaches the field in the
 * first place. Letting somebody type an Arabic name or an `@` and refusing it on submit is a worse
 * answer: by then they have written something they believed in.
 *
 * A trailing hyphen survives, and a doubled one collapses to it, because both mean the same thing:
 * the person is between two words. The leading one cannot, since there is no word before it.
 */
export const sanitizeSlugInput = (value: string): string =>
    value
        .toLowerCase()
        .replace(/[^a-z0-9-]/g, "")
        .replace(/-{2,}/g, "-")
        .replace(/^-+/, "");

/** The full rule, for submit time — the typed value may still end in the hyphen it is mid-word on. */
export const isValidSlug = (value: string): boolean => SLUG_REGEX.test(value.trim());
